import kformUtils from '~/components/kform/utils/kform-utils';

export default /* @ngInject */ (
	/** @type {any} */ $copyToClipboard,
	/** @type {import('angular').IFilterService} */ $filter,
	/** @type {any} */ $scope,
	/** @type {import('angular').translate.ITranslateService} */ $translate,
	/** @type {import('angular').IWindowService} */ $window,
) => {
	$scope.uriRegex = /^([a-z][\d+.a-z-]*):(?:\/\/((?:(?=((?:[\w!$&'()*+,.:;=~-]|%[\da-f]{2})*))(\3)@)?(?=(\[[\d.:a-f]{2,}]|(?:[\w!$&'()*+,.;=~-]|%[\da-f]{2})*))\5(?::(?=(\d*))\6)?)(\/(?=((?:[\w!$&'()*+,./:;=@~-]|%[\da-f]{2})*))\8)?|(\/?(?!\/)(?=((?:[\w!$&'()*+,./:;=@~-]|%[\da-f]{2})*))\10)?)(?:\?(?=((?:[\w!$&'()*+,./:;=?@~-]|%[\da-f]{2})*))\11)?(?:#(?=((?:[\w!$&'()*+,./:;=?@~-]|%[\da-f]{2})*))\12)?$/i;

	if ($scope.options?.building) {
		return;
	}

	$scope.copyURI = () => {
		$copyToClipboard(
			$scope.data[$scope.component.key],
			true,
			(/** @type {string} */ v) => $filter('sprintf')(
				$translate.instant('common.x-copied-to-clipboard'),
				v,
			),
		);
	}

	$scope.changeValue = () => {
		if (typeof $scope.component.event.onChange === 'string') {
			const custom = ''.concat($scope.component.event.onChange, '; ');
			kformUtils.evaluate(custom, {
				data: $scope.data,
				form: $scope.form,
			});
		}
	};

	$scope.checkValue = () => $scope.data
		? $scope.uriRegex.test($scope.data[$scope.component.key]) : true;

	$scope.openURI = () => $scope.data
		? $window.open($scope.data[$scope.component.key], '_blank') : false;
};
